// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1126":"c49d0deb","2678":"e7648ebf","6290":"93fecbab","6461":"c49d0deb"}[chunkId] + ".chunk.css";
};